import { render, staticRenderFns } from "./BlockQRcode.vue?vue&type=template&id=1fd695bf"
import script from "./BlockQRcode.vue?vue&type=script&lang=js"
export * from "./BlockQRcode.vue?vue&type=script&lang=js"
import style0 from "./BlockQRcode.vue?vue&type=style&index=0&id=1fd695bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports